import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);
export default new Vuetify({
  rtl: true,
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        background: localStorage.getItem('background')
          ? localStorage.getItem('background')
          : '#f6fbff',
        darkColor: localStorage.getItem('darkColor')
          ? localStorage.getItem('darkColor')
          : '#04468B',
        lightColor: localStorage.getItem('lightColor')
          ? localStorage.getItem('lightColor')
          : '#0A6ADA',
        iconColor: localStorage.getItem('iconColor')
          ? localStorage.getItem('iconColor')
          : '#0857B0',
        textLightColor: localStorage.getItem('textLightColor')
          ? localStorage.getItem('textLightColor')
          : '#4173a8',
        modalBorder: localStorage.getItem('modalBorder')
          ? localStorage.getItem('modalBorder')
          : '#4878aa',
        oneFieldcolor: localStorage.getItem('oneFieldcolor')
          ? localStorage.getItem('oneFieldcolor')
          : '#81a3c5',
        newCallEffect: localStorage.getItem('newCallEffect')
          ? localStorage.getItem('newCallEffect')
          : '#70B2FF',
      } /*
      dark: {
        background: "#CBEF37",
        primary: localStorage.getItem("primary") ? localStorage.getItem("primary") : "#CBEF37",
        lightColor: "#0A6ADA",
        iconColor: "#0857B0",
      }*/,
    },
  },
});
